module.exports = __webpack_public_path__ + "img/security2-logo31.d3c0be57.png";